/**
 * Event bus which forwards server-side organization events.
 *
 * This is a singleton so every import gets the same instance.
 */
export const ORGANIZATION_EVENTS_RECONNECTED_EVENT =
    'organization-events-reconnected';
export const ORGANIZATION_EVENTS_CONNECTION_OPENED_EVENT =
    'organization-events-connection-opened';
export const ORGANIZATION_EVENTS_CONNECTION_CLOSED_EVENT =
    'organization-events-connection-closed';
// Fired when a delivered event's org_seq shows a gap: at least one
// organization event was published but never reached this client.
export const ORGANIZATION_EVENTS_GAP_DETECTED_EVENT =
    'organization-events-gap-detected';

export type OrganizationEventsReconnectedDetail = {
    readonly organizationId: string;
};

export type OrganizationEventsGapDetectedDetail = {
    readonly organizationId: string;
};

export type OrganizationEventsConnectionDetail = {
    readonly organizationId: string;
};

export type OrganizationEventBusDetail<T> = {
    readonly organizationId: string | null;
    readonly event: T;
};

export const organizationEventBus = new EventTarget();

// Fired whenever the session provider confirms a live session against Ory,
// including the revalidation that follows a recovered credential. Kept off
// `organizationEventBus` because a session is not scoped to an organization,
// and folding it in would deliver session traffic to every organization-event
// consumer.
export const SESSION_VALIDATED_EVENT = 'session-validated';

export const sessionEventBus = new EventTarget();

export function isOrganizationEventTestEnvironment(
    hostname: string,
    isDevelopmentEnvironment: boolean,
): boolean {
    if (!isDevelopmentEnvironment) {
        return false;
    }

    // Private Daytona local-app tests use this HTTPS hostname so auth and
    // secure-cookie behavior match a deployed app without exposing test seams
    // in staging or production builds.
    return (
        ['localhost', '127.0.0.1'].includes(hostname) ||
        hostname === 'phoebe.daytona.internal'
    );
}
